import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from "@/store";
import exportJsonV2 from "@/utils/exporter";
import IconButton from "./IconButton.vue";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t, locale } = useI18n();
const store = useStore();
function share() {
  const version = 2;
  const snakes = store.isRunning ? store.beforePlaySnakes : store.snakes;
  const json = exportJsonV2(Object.values(snakes));
  const baseUrl = "https://twitter.com/intent/tweet?";
  const text = ["text", t("twitterShare")];
  const origin = location.origin.includes("localhost")
    ? "https://genochemy.netlify.app"
    : location.origin;
  const url = [
    "url",
    `${origin}/?c=${btoa(JSON.stringify(json))}&v=${version}&l=${locale.value}`,
  ];
  const hashtags = ["hashtags", "genochemy"];
  const query = new URLSearchParams([text, url, hashtags]).toString();
  window.open(`${baseUrl}${query}`);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(IconButton, {
    onClick: share,
    "background-color": "#00ACEE",
    color: "white"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_font_awesome_icon, { icon: _unref(faTwitter) }, null, 8, ["icon"])
    ]),
    _: 1
  }))
}
}

})